import { CellContent } from 'shared/types/models/EditMetrics';

export function isEmptyValue(value: CellContent) {
  return value === null || value === '' || value === false;
}
